module.exports = __webpack_public_path__ + "img/keywords_how_it_works.ac3e646d.svg";